module.exports = __webpack_public_path__ + "img/hy-pb-title.f15cfac0.png";